import AnalyticsService from "../services/AnalyticsService";

// ONE entry point for every WhatsApp CTA on the AI Mentions page (hero primary +
// final CTA), so the two can never drift into different numbers or messages.
// The prefill is Hebrew and contains '?' and '/', all of which must survive the
// query string - hence the encode.
export const whatsappUrl = (number: string, prefill: string): string =>
    `https://wa.me/${number}?text=${encodeURIComponent(prefill.trim())}`;

export const openWhatsapp = (number: string, prefill: string): void => {
    window.open(whatsappUrl(number, prefill), '_blank', 'noopener');
    // Same event the other WhatsApp entry points already report
    AnalyticsService.getInstance().sendPageViewEvent({pagePath: 'whatsapp'});
};
